import { useEffect } from 'react';
import type { SettingsStore } from '@ports/SettingsStore.ts';

export const THEME_MIGRATED_KEY = 'rikosub:theme-migrated-v1';

/**
 * Apply `settings.darkMode` to `document.documentElement.dataset.theme`.
 * One-shot: users who never had a theme toggle keep dark chrome (historical mobile default).
 */
export function useThemeFromSettings(settingsStore: SettingsStore): void {
  useEffect(() => {
    try {
      if (typeof localStorage !== 'undefined' && !localStorage.getItem(THEME_MIGRATED_KEY)) {
        localStorage.setItem(THEME_MIGRATED_KEY, '1');
        const snap = settingsStore.getSnapshot?.() ?? null;
        if (snap && !snap.darkMode) {
          void settingsStore.set({ darkMode: true });
        }
      }
    } catch {
      // private mode
    }

    const apply = () => {
      const dark = settingsStore.getSnapshot?.()?.darkMode ?? true;
      document.documentElement.dataset.theme = dark ? 'dark' : 'light';
      document.documentElement.style.colorScheme = dark ? 'dark' : 'light';
    };
    apply();
    return settingsStore.subscribe(() => apply());
  }, [settingsStore]);
}
